module.exports = __webpack_public_path__ + "img/carousel-servicios-1.37ece5e5.jpg";